import React from 'react';
import { Activity } from 'lucide-react';

interface ScanStatusMenuProps {
  className?: string;
}

export const ScanStatusMenu: React.FC<ScanStatusMenuProps> = ({ className }) => {
  return (
    <div className={`relative z-50 ${className || ''}`}>
      <div className="absolute top-full right-0 mt-2 w-64 opacity-0 invisible group-hover:opacity-100 group-hover:visible hover:opacity-100 hover:visible transition-all duration-150 ease-in-out">        
        <div className="bg-[#1A1F2E] rounded-lg border border-gray-800 shadow-xl">
          <div className="p-4 space-y-3">
            <h3 className="text-sm font-medium text-white mb-2">Scan Status</h3>
            
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-800/30 rounded-lg">
                <div className="flex items-center space-x-2">
                  {/* <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse" /> */}
                  {/* <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse" /> */}
                  <div className="h-2 w-2 rounded-full bg-yellow-500" />
                  <span className="text-sm text-white">API Scan</span>
                </div>
                {/* <span className="text-xs text-green-500">Active</span> */}
                <span className="text-xs text-yellow-500">On Hold</span>
              </div>

              <div className="flex items-center justify-between p-2 bg-gray-800/30 rounded-lg">
                <div className="flex items-center space-x-2">
                  <div className="h-2 w-2 rounded-full bg-yellow-500" />
                  <span className="text-sm text-white">Infrastructure Scan</span>
                </div>
                <span className="text-xs text-yellow-500">On Hold</span>
              </div>

              <div className="flex items-center justify-between p-2 bg-gray-800/30 rounded-lg">
                <div className="flex items-center space-x-2">
                  {/* <div className="h-2 w-2 rounded-full bg-blue-500" /> */}
                  <div className="h-2 w-2 rounded-full bg-yellow-500" />
                  <span className="text-sm text-white">Code Analysis</span>
                </div>
                {/* <span className="text-xs text-blue-500">Monitoring</span> */}
                <span className="text-xs text-yellow-500">On Hold</span>
              </div>
            </div>

            <button className="w-full mt-2 p-2 text-sm text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-colors">
              View All Scans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};